// extracted by mini-css-extract-plugin
export default {"container":"otherDetails_container__oQhYI","cards":"otherDetails_cards__asrxs","card":"otherDetails_card__Pdrdk","bigCard":"otherDetails_bigCard__GEboS"};